import * as React from 'react'
import { DropdownContextValue } from './Dropdown.types'

const DropdownContext = React.createContext<DropdownContextValue | null>(null)

export default DropdownContext
